import axios from "@/plugins/axios"
const token = localStorage.getItem("token");

export default {
    // async getAllAutoJobCards(){
    //     let jobCards = [];
    //     const response = await axios.getData("/auth/get-All-service-cards", token);
    //     if (response?.status === "success") {
    //         jobCards = response.services;
    //     }
    //     return jobCards;
    // },

    async getPracticeByInvoiceNumber(table,invoiceNumber){
        let practice = null;
        const response = await axios.postDataWithToken("/auth/get-practice-by-invoice-number",{table, invoiceNumber},token);
        if (response?.status === "success") {
            practice = response.practice;
        }
        return practice;
        
    }
}